@file:OptIn(InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/chartsproject.app.generated.resources/"

internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

internal val Res.string.bar_chart: StringResource by lazy {
      StringResource("string:bar_chart", "bar_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 21),
      ))
    }

internal val Res.string.bar_stacked_chart: StringResource by lazy {
      StringResource("string:bar_stacked_chart", "bar_stacked_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57, 41),
      ))
    }

internal val Res.string.chart_basic: StringResource by lazy {
      StringResource("string:chart_basic", "chart_basic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99, 27),
      ))
    }

internal val Res.string.chart_custom: StringResource by lazy {
      StringResource("string:chart_custom", "chart_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127, 28),
      ))
    }

internal val Res.string.github_url: StringResource by lazy {
      StringResource("string:github_url", "github_url", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219, 70),
      ))
    }

internal val Res.string.github_url_content_description: StringResource by lazy {
      StringResource("string:github_url_content_description", "github_url_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156, 62),
      ))
    }

internal val Res.string.line_chart: StringResource by lazy {
      StringResource("string:line_chart", "line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290, 26),
      ))
    }

internal val Res.string.multi_line_chart: StringResource by lazy {
      StringResource("string:multi_line_chart", "multi_line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317, 40),
      ))
    }

internal val Res.string.pie_chart: StringResource by lazy {
      StringResource("string:pie_chart", "pie_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 358, 21),
      ))
    }

internal val Res.string.themes_content_description: StringResource by lazy {
      StringResource("string:themes_content_description", "themes_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 380, 58),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("bar_chart", Res.string.bar_chart)
  map.put("bar_stacked_chart", Res.string.bar_stacked_chart)
  map.put("chart_basic", Res.string.chart_basic)
  map.put("chart_custom", Res.string.chart_custom)
  map.put("github_url", Res.string.github_url)
  map.put("github_url_content_description", Res.string.github_url_content_description)
  map.put("line_chart", Res.string.line_chart)
  map.put("multi_line_chart", Res.string.multi_line_chart)
  map.put("pie_chart", Res.string.pie_chart)
  map.put("themes_content_description", Res.string.themes_content_description)
}
